import gql from 'graphql-tag';

import tasksPageFragment from '../fragments/tasksPageFragment';

export const queryTasksPage = gql`
  query tasksPage(
    $sourceDokkioObjectID: DokkioID
    $offset: Int
    $count: Int
  ) {
    tasksPage(
      sourceDokkioObjectID: $sourceDokkioObjectID
      offset: $offset
      count: $count
    ) {
      ...tasksPageFragment
    }
  }
  ${tasksPageFragment}
`;

export default queryTasksPage;
